import { render, staticRenderFns } from "./FreeNewsroomButton.vue?vue&type=template&id=9c8f0038"
import script from "./FreeNewsroomButton.vue?vue&type=script&lang=js"
export * from "./FreeNewsroomButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports